'use strict';

module.exports = /* @ngInject */ function() {
  return {
    restrict: 'AE',
    scope: {
      filterModel: '='
    },
    template: 	'<div class="form-group form-group-sm has-feedback">' +
				'	<input type="text" class="form-control" placeholder="' + gettxt.form.search + '"  ng-model="filterModel" />' +
				'	<i class="glyphicon glyphicon-search form-control-feedback"></i>' +
				'</div>',
    replace: true,
    link: function($scope, elem, attr, ctrl) {}
  };
}
